import { type ReactElement } from 'react'
import { useLocationAddress, useTranslation } from '@front/model'
import type { LocationId } from '@terros/common'
import { TButton, type TButtonProps } from '../buttons'

type Props = {
  locationId?: LocationId
  onClick: VoidFunction
} & Omit<TButtonProps, 'onClick' | 'children'>

export const PickLocation = ({ locationId, onClick, ...props }: Props): ReactElement => {
  const { t } = useTranslation()
  const address = useLocationAddress(locationId)
  return (
    <TButton
      icon='location_on'
      justify='start'
      size='medium'
      variant={locationId ? 'secondary' : 'primary'}
      {...props}
      onClick={onClick}
    >
      {locationId ? address : t('Enter Location')}
    </TButton>
  )
}
